import { createSlice } from '@reduxjs/toolkit';
import { getAccountTransactions } from './thunk';

export const initialState = {
  isLoading: false,
  accountTransactions: [],
  accountTransaction: {},
  meta: {},
  error: {},
  filters: [],
  isError: false,
};

const accountTransactionSlice = createSlice({
  name: 'AccountTransaction',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAccountTransactions.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAccountTransactions.fulfilled, (state, action) => {
      state.isLoading = false;
      state.accountTransactions = action.payload?.data;
      state.meta = action.payload?.meta;
    });
    builder.addCase(getAccountTransactions.rejected, (state, action) => {
      state.isError = true;
      state.error = action.payload?.error || null;
      console.log(action);
    });
  },
});

export default accountTransactionSlice.reducer;
